module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_dress-bfd13cb1a9854a6a9de7b731999eb80b.webp";